import React from "react";

import Session from 'components/LM/Auth/Session';

const DEFAULT_BEHAVIOUR = 'no_render';


function Permissions (props) {
	const { permissions } = props;
	let { behaviour } = props;
	const { children } = props;


	const session = new Session();

	if (!behaviour) behaviour = DEFAULT_BEHAVIOUR;

	const userHasAllPermissions = permissions.every(p => session.hasPermission(p));
	if (userHasAllPermissions) {
		return (children);
	} else if (behaviour === 'no_render') {
		return null;
	} else if (behaviour === 'error') {
		return (<Error />);
	} else {
		throw new Error(`Unknown behaviour: ${behaviour}`);
	}
}

function Error() {
	return (
		<div className="text-center">
			<p className="h1">Not enough permissions</p>
			<p className="h2 font-weight-normal mt-3 mb-4">
				Your user hasn't the required permissions to access to this page
			</p>
		</div>);
}

export default Permissions;
